import * as ActionUtilities from '@utilities/action-utility'

const NEXT_STEP = 'Aberto.Onboarding-NEXT_STEP'
const BACK_STEP = 'Aberto.Onboarding-BACK_STEP'

const nextStep = () => ActionUtilities.createAction(NEXT_STEP)
const backStep = () => ActionUtilities.createAction(BACK_STEP)

export { NEXT_STEP, BACK_STEP, nextStep, backStep }
